// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {

  
  html {
    scroll-behavior: smooth;
  }
  #root, .App {
  display: flex;
  flex-direction: column; /* Makes the layout vertical */
  height: 80vh!important; /* Ensures the app spans the full viewport height */
}
body {
  margin:0;
  padding: 0;
}

main {
  flex: 1 1; /* Ensures the main content stretches to fill the available space */
  padding-top: 70px;
}

  font-family: Arial, sans-serif;
  padding: 0;
  overflow-x:hidden ;
  margin: 0;
}






.about123
{
  padding-top: 90px;
  padding-bottom: 0px;

}

.service123
 {
  padding-top: 50px;
  padding-bottom: -40px;
}

.homologation123
{
  padding-top: 70px;

}
.dashboard123
{
  padding-top: 50%;
  padding-bottom :70px; ;
}
.services123
{
  padding-top: 50%;
  padding-bottom :70px; 
}
.circular123
{
  padding: 0%;
  padding-bottom: 0%;
}
.ITNetworkFirst123
{
  padding: auto;
  padding-bottom: 0%;
}
.Navbar {
 
  top: 0;
  background-color: #fff; /* Background color to make it stand out */
  z-index: 10; /* Ensures it stays above the image */

  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* Optional: to add a shadow effect */
}
.Navbar
{
  position: sticky;
  
}



/* Scrolling Buttons Styling */
.scrolling-buttons {
  position: absolute;
  bottom: 140px; /* Position buttons at the bottom of the hero image */
  left: 50%; /* Center horizontally within the image */
  transform: translateX(-50%); /* Adjust to truly center */
  display: flex;
  gap: 20px; /* Space between buttons */
}

.scroll-btn {
  width: 30px;
  height: 30px;
  background-color: #90F011; /* Green color for buttons */
  color: white;
  border: none;
  border-radius: 50%; /* Make buttons circular */
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease; /* Smooth transition for hover effects */
  opacity: 0.5; /* Default opacity for non-active buttons */
}

.scroll-btn.active {
  background-color: #90F011; /* Darker green on active state */
  transform: scale(1.2); /* Pop-up effect */
  opacity: 1; /* Fully visible when active */
}

.scroll-btn:hover {
  background-color: #085521e3; /* Darker green on hover */
  transform: scale(1.2); /* Pop-up effect on hover */
}

.scroll-btn:hover ~ .scroll-btn,
.scroll-btn:hover + .scroll-btn {
  opacity: 0.2; /* Make non-hovered buttons slightly transparent */
}

.Footer {
  position: fixed;
  bottom: 0; /* Stick to the bottom of the viewport */
  background-color: #fff; /* Background color for the footer */
  z-index: 10; /* Ensure it appears above other elements */
  text-align: center; /* Center-align text or content */
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional: shadow effect for better visibility */
  padding: 0; /* Padding for some spacing inside the footer */
  width: 100%; /* Ensure the footer spans the full width */
}





`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;;;EAGE;IACE,uBAAuB;EACzB;EACA;EACA,aAAa;EACb,sBAAsB,EAAE,8BAA8B;EACtD,sBAAsB,EAAE,mDAAmD;AAC7E;AACA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,SAAO,EAAE,mEAAmE;EAC5E,iBAAiB;AACnB;;EAEE,8BAA8B;EAC9B,UAAU;EACV,kBAAkB;EAClB,SAAS;AACX;;;;;;;AAOA;;EAEE,iBAAiB;EACjB,mBAAmB;;AAErB;;AAEA;;EAEE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;;AAEnB;AACA;;EAEE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;EAEE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;EAEE,WAAW;EACX,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,kBAAkB;AACpB;AACA;;EAEE,MAAM;EACN,sBAAsB,EAAE,0CAA0C;EAClE,WAAW,EAAE,qCAAqC;;EAElD,kBAAkB;EAClB,yCAAyC,EAAE,qCAAqC;AAClF;AACA;;EAEE,gBAAgB;;AAElB;;;;AAIA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,aAAa,EAAE,qDAAqD;EACpE,SAAS,EAAE,yCAAyC;EACpD,2BAA2B,EAAE,2BAA2B;EACxD,aAAa;EACb,SAAS,EAAE,0BAA0B;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,4BAA4B;EACvD,YAAY;EACZ,YAAY;EACZ,kBAAkB,EAAE,0BAA0B;EAC9C,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB,EAAE,wCAAwC;EACnE,YAAY,EAAE,2CAA2C;AAC3D;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,qBAAqB,EAAE,kBAAkB;EACzC,UAAU,EAAE,8BAA8B;AAC5C;;AAEA;EACE,2BAA2B,EAAE,0BAA0B;EACvD,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;;EAEE,YAAY,EAAE,kDAAkD;AAClE;;AAEA;EACE,eAAe;EACf,SAAS,EAAE,wCAAwC;EACnD,sBAAsB,EAAE,oCAAoC;EAC5D,WAAW,EAAE,2CAA2C;EACxD,kBAAkB,EAAE,iCAAiC;EACrD,0CAA0C,EAAE,kDAAkD;EAC9F,UAAU,EAAE,+CAA+C;EAC3D,WAAW,EAAE,2CAA2C;AAC1D","sourcesContent":["@import \"@fortawesome/fontawesome-free/css/all.min.css\";\n\n.App {\n\n  \n  html {\n    scroll-behavior: smooth;\n  }\n  #root, .App {\n  display: flex;\n  flex-direction: column; /* Makes the layout vertical */\n  height: 80vh!important; /* Ensures the app spans the full viewport height */\n}\nbody {\n  margin:0;\n  padding: 0;\n}\n\nmain {\n  flex: 1; /* Ensures the main content stretches to fill the available space */\n  padding-top: 70px;\n}\n\n  font-family: Arial, sans-serif;\n  padding: 0;\n  overflow-x:hidden ;\n  margin: 0;\n}\n\n\n\n\n\n\n.about123\n{\n  padding-top: 90px;\n  padding-bottom: 0px;\n\n}\n\n.service123\n {\n  padding-top: 50px;\n  padding-bottom: -40px;\n}\n\n.homologation123\n{\n  padding-top: 70px;\n\n}\n.dashboard123\n{\n  padding-top: 50%;\n  padding-bottom :70px; ;\n}\n.services123\n{\n  padding-top: 50%;\n  padding-bottom :70px; \n}\n.circular123\n{\n  padding: 0%;\n  padding-bottom: 0%;\n}\n.ITNetworkFirst123\n{\n  padding: auto;\n  padding-bottom: 0%;\n}\n.Navbar {\n \n  top: 0;\n  background-color: #fff; /* Background color to make it stand out */\n  z-index: 10; /* Ensures it stays above the image */\n\n  text-align: center;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* Optional: to add a shadow effect */\n}\n.Navbar\n{\n  position: sticky;\n  \n}\n\n\n\n/* Scrolling Buttons Styling */\n.scrolling-buttons {\n  position: absolute;\n  bottom: 140px; /* Position buttons at the bottom of the hero image */\n  left: 50%; /* Center horizontally within the image */\n  transform: translateX(-50%); /* Adjust to truly center */\n  display: flex;\n  gap: 20px; /* Space between buttons */\n}\n\n.scroll-btn {\n  width: 30px;\n  height: 30px;\n  background-color: #90F011; /* Green color for buttons */\n  color: white;\n  border: none;\n  border-radius: 50%; /* Make buttons circular */\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease; /* Smooth transition for hover effects */\n  opacity: 0.5; /* Default opacity for non-active buttons */\n}\n\n.scroll-btn.active {\n  background-color: #90F011; /* Darker green on active state */\n  transform: scale(1.2); /* Pop-up effect */\n  opacity: 1; /* Fully visible when active */\n}\n\n.scroll-btn:hover {\n  background-color: #085521e3; /* Darker green on hover */\n  transform: scale(1.2); /* Pop-up effect on hover */\n}\n\n.scroll-btn:hover ~ .scroll-btn,\n.scroll-btn:hover + .scroll-btn {\n  opacity: 0.2; /* Make non-hovered buttons slightly transparent */\n}\n\n.Footer {\n  position: fixed;\n  bottom: 0; /* Stick to the bottom of the viewport */\n  background-color: #fff; /* Background color for the footer */\n  z-index: 10; /* Ensure it appears above other elements */\n  text-align: center; /* Center-align text or content */\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional: shadow effect for better visibility */\n  padding: 0; /* Padding for some spacing inside the footer */\n  width: 100%; /* Ensure the footer spans the full width */\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
